import { render, staticRenderFns } from "./Requerente.vue?vue&type=template&id=0cb1633b&"
import script from "./Requerente.vue?vue&type=script&lang=js&"
export * from "./Requerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Requerente.vue"
export default component.exports